import type { LeadFlowAnswers } from "../types";

type CareTypeValue = keyof NonNullable<LeadFlowAnswers["careType"]>;

/** The care types the visitor checked, in the answer's key order. */
function getSelectedCareTypes(answers: LeadFlowAnswers): CareTypeValue[] {
  return Object.entries(answers.careType ?? {}).flatMap(
    ([careType, isSelected]) => (isSelected ? [careType as CareTypeValue] : []),
  );
}

export { getSelectedCareTypes };
